import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4443" />
      <ArchitectureDiagram data-id="element-4444" />
      <HowItWorksConnections mode="how" data-id="element-4445" />
      <LivesInSlack data-id="element-4446" />
      <ComputerUse data-id="element-4447" />
      <CapabilityGrid data-id="element-4448" />
      <NarrativeSection data-id="element-4449" />
      <ToolComparison data-id="element-4450" />
      <WallOfLove data-id="element-4451" />
      <PricingSection data-id="element-4452" />
      <ClosingCTA data-id="element-4453" />
    </>;
}